var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete 1",
    clipPath: "url(#clip0_676_25533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.6516 10.0427C48.6202 10.0529 37.6439 13.2871 37.6127 13.2978C36.436 13.7071 35.6454 14.8192 35.6454 16.0651V21.0131C35.6454 21.984 36.4324 22.771 37.4033 22.771H50.7636C51.7345 22.771 52.5216 21.984 52.5216 21.0131V12.8176C52.5216 10.8164 50.5508 9.39897 48.6516 10.0427Z",
    fill: "#FF5E94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7692 19.2559V52.3759C18.7692 56.5763 22.1865 59.9936 26.3869 59.9936H44.904C49.1044 59.9936 52.5217 56.5763 52.5217 52.3759C52.5217 50.532 52.5217 20.1808 52.5217 19.2559H18.7692Z",
    fill: "#9DCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.6454 19.2559V59.9936H44.9039C49.1043 59.9936 52.5217 56.5762 52.5217 52.3759V19.2559H35.6454Z",
    fill: "#72BBFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.8242 27.3389C26.8533 27.3389 26.0663 28.1259 26.0663 29.0968V50.1455C26.0663 51.1164 26.8533 51.9035 27.8242 51.9035C28.7951 51.9035 29.5821 51.1164 29.5821 50.1455V29.0968C29.5821 28.1259 28.795 27.3389 27.8242 27.3389Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.6453 27.3389C34.6744 27.3389 33.8873 28.1259 33.8873 29.0968V50.1455C33.8873 51.1164 34.6744 51.9035 35.6453 51.9035C36.6162 51.9035 37.4032 51.1164 37.4032 50.1455V29.0968C37.4032 28.1259 36.6162 27.3389 35.6453 27.3389Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.4031 29.0968V50.1452C37.4031 51.1156 36.6156 51.9031 35.6451 51.9031V27.3389C36.6156 27.3389 37.4031 28.1252 37.4031 29.0968Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.4663 27.3389C42.4954 27.3389 41.7084 28.1259 41.7084 29.0968V50.1455C41.7084 51.1164 42.4954 51.9035 43.4663 51.9035C44.4372 51.9035 45.2242 51.1164 45.2242 50.1455V29.0968C45.2242 28.1259 44.4372 27.3389 43.4663 27.3389Z",
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.5202 2.1118C22.5202 2.1118 22.5202 2.1118 22.5191 2.1118C20.7219 0.98821 18.2984 1.19856 16.723 2.77391V2.77508L13.4909 6.00594L10.2589 9.23798C8.43079 11.0661 8.43079 14.0403 10.2589 15.8673L11.9171 17.5255L14.2972 17.2794L14.4027 15.0388L12.7456 13.3817C12.2886 12.9247 12.2886 12.1806 12.7456 11.7247L15.9777 8.49266L19.2085 5.26063H19.2097C19.642 4.82833 20.3845 4.77829 20.8656 5.25946L22.5238 6.91766L24.6976 6.55673L25.0105 4.43212C23.2754 2.69704 23.0874 2.46126 22.5202 2.1118Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.5201 2.11189C22.5201 2.11189 22.5201 2.11189 22.519 2.11189C20.7264 0.991107 18.304 1.19419 16.7229 2.77517L13.4908 6.00603L15.9776 8.49275L19.2096 5.26072C19.6415 4.82876 20.3835 4.77744 20.8655 5.25954L22.5237 6.91775L25.0104 4.4322C23.2185 2.64029 23.1164 2.48994 22.5201 2.11189Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.1977 4.34167L34.0486 1.19261C32.4493 -0.40665 29.8471 -0.40665 28.2477 1.19261L8.67833 20.7619C7.07907 22.3611 7.07907 24.9634 8.67833 26.5628L11.8274 29.7118C12.5138 30.3983 13.6269 30.3984 14.3134 29.7118L37.1977 6.82769C37.8841 6.1412 37.8841 5.02815 37.1977 4.34167Z",
    fill: "#3BA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.0485 1.1927L37.1975 4.34176C37.8837 5.02789 37.8845 6.14082 37.1975 6.82789L25.7557 18.2697L18.4631 10.9771L28.2476 1.1927C29.847 -0.40668 32.4491 -0.40668 34.0485 1.1927Z",
    fill: "#0081FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_25533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModal);
export default __webpack_public_path__ + "static/media/delete-modal.294370cca56ab2a1249be1c2ada4895f.svg";
export { ForwardRef as ReactComponent };